module.exports = __webpack_public_path__ + "img/GALLERY-S-CROSS-5.ce48a5ac.jpg";